{
    "Accessibility menu": "Меню за достъпност",
    "Close": "Затвори",
    "Content adjustments": "Настройки на съдържанието",
    "Navigation adjustments": "Настройки на навигацията",
    "Text Align": "Text Align",
    "Align Left": "Подравни вляво",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "Настройка на размера на шрифта",
    "Highlight Title": "Открояване на заглавието",
    "Highlight Links": "Открояване на връзките",
    "Readable Font": "Четим шрифт",
    "Colour adjustments": "Настройки на цветовете",
    "Dark Contrast": "Тъмен контраст",
    "Light Contrast": "Светъл контраст",
    "High Contrast": "Висок контраст",
    "High Saturation": "Висока наситеност",
    "Low Saturation": "Ниска наситеност",
    "Monochrome": "Монохромен",
    "Tools": "Инструменти",
    "Reading Guide": "Ръководство за четене",
    "Big Cursor": "Голям курсор",
    "Increase Font Size": "Увеличи размера на шрифта",
    "Decrease Font Size": "Намали размера на шрифта",
    "Letter Spacing": "Разстояние между буквите",
    "Line Height": "Височина на реда",
    "Font Weight": "Дебелина на шрифта",
    "Dyslexia Font": "Шрифт за дислексия",
    "Language": "Език",
    "Accessibility widget": "Отвори меню за достъпност",
    "Accessibility Profiles": "Профили за достъпност",
    "Cognitive Disability": "Когнитивна увреденост",
    "Seizure Safe": "Безопасно за епилепсия",
    "Accessibility statement": "Декларация за достъпност",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Спри анимациите",
    "Animation paused": "Анимацията е спряна",
    "Reset all settings": "Нулиране на настройките",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
